module.exports = (__webpack_require__(7))(874);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/tslib/tslib.es6.js from dll-reference vendor
// module id = 1206
// module chunks = 0